var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeLoader)?_c('v-row',{staticClass:"modal",attrs:{"justify":"center","align":"center","data-test":"loaderElement"}},[_c('img',{attrs:{"width":"40%","src":require("../assets/logo.png")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }